// PIXXI CRM API integration utility
const PIXXI_API_URL = 'https://dataapi.pixxicrm.ae/pixxiapi/webhook/v1/form';
const PIXXI_TOKEN = 'Zz2acWXOtmLew7gXsgq86xSpRHdpKneq';
const FORM_ID = '0baa9048-af1d-48f5-83e4-b46334b161cd';
const FORM_ID_WEBSITE_LISTING_BUY = '229bb3b4-1709-40a6-a7a6-d0e471023104';
const FORM_ID_WEBSITE_LISTING_RENT = '320fe45e-6443-481e-9e12-38017f0adb2e';
const FORM_ID_WEBSITE_PROPERTY_SEARCH = '61539f6b-0920-4768-9bcd-1aa3dd705eae';

export async function submitToPixxiCRM(formData) {
  try {
    const headers = new Headers();
    headers.append('X-PIXXI-TOKEN', PIXXI_TOKEN);
    headers.append('Content-Type', 'application/json');

    // Map form data to PIXXI format
    const pixxiData = {
      formId: FORM_ID,
      name: formData.name || 'Unknown',
      phone: formData.fullPhoneNumber || formData.phone || '',
      email: formData.email || '',
      nationality: formData.country || formData.nationality || 'UAE',
      extraData: {
        // message: formData.message || '',
        unit_type: formData.extraData?.unitType || '',
        form_type: formData.formType || 'contact',
        // language: formData.language || formData.preferredLanguage || 'en',
        country_code: formData.countryCode || '',
        source:
          formData?.extraData?.source ||
          'Modal Popup Contact Form - X-Space Real Estate Marketing Campaign Website',

        timestamp: new Date().toISOString(),
        ...(formData.extraData || {}),
      },
    };

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(pixxiData),
      redirect: 'follow',
    };

    const response = await fetch(PIXXI_API_URL, requestOptions);
    const result = await response.text();

    if (response.ok) {
      console.log('PIXXI CRM submission successful:', result);
      return {
        success: true,
        message: 'Form submitted successfully',
        data: result,
      };
    } else {
      console.error('PIXXI CRM submission failed:', response.status, result);
      return {
        success: false,
        message: 'Failed to submit form',
        error: result,
      };
    }
  } catch (error) {
    console.error('PIXXI CRM API error:', error);
    return {
      success: false,
      message: 'Network error occurred',
      error: error.message,
    };
  }
}

export async function submitToPixxiCRMWebsiteListing(formData) {
  try {
    const headers = new Headers();
    headers.append('X-PIXXI-TOKEN', PIXXI_TOKEN);
    headers.append('Content-Type', 'application/json');

    // Determine which form ID to use based on property_url
    let formId = FORM_ID_WEBSITE_LISTING_RENT; // default
    let propertyType = 'Rent'; // default
    const propertyUrl = formData?.extraData?.property_url || '';

    if (propertyUrl.includes('buy') || propertyUrl.includes('off-plan')) {
      formId = FORM_ID_WEBSITE_LISTING_BUY;
      propertyType = 'Buy';
    }

    // Map form data to PIXXI format
    const pixxiData = {
      formId,
      name: formData.name || 'Unknown',
      phone: formData.fullPhoneNumber || formData.phone || '',
      email: formData.email || '',
      // nationality: formData.country || formData.nationality || 'UAE',
      extraData: {
        form_type: formData.formType || 'contact',
        source: formData?.extraData?.source || 'Website Lead Form',
        property_type: propertyType,
        form_type: `Website Listing - ${propertyType}`,
        timestamp: new Date().toISOString(),
        ...(formData.extraData || {}),
      },
    };

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(pixxiData),
      redirect: 'follow',
    };

    const response = await fetch(PIXXI_API_URL, requestOptions);
    const result = await response.text();

    if (response.ok) {
      console.log('PIXXI CRM submission successful:', result);
      return {
        success: true,
        message: 'Form submitted successfully',
        data: result,
      };
    } else {
      console.error('PIXXI CRM submission failed:', response.status, result);
      return {
        success: false,
        message: 'Failed to submit form',
        error: result,
      };
    }
  } catch (error) {
    console.error('PIXXI CRM API error:', error);
    return {
      success: false,
      message: 'Network error occurred',
      error: error.message,
    };
  }
}

export async function submitGeneralFormToPixxiCRM(formData) {
  try {
    const headers = new Headers();
    headers.append('X-PIXXI-TOKEN', PIXXI_TOKEN);
    headers.append('Content-Type', 'application/json');

    // Map form data to PIXXI format
    const pixxiData = {
      formId: FORM_ID_WEBSITE_PROPERTY_SEARCH,
      name: formData.name || 'Unknown',
      phone: formData.fullPhoneNumber || formData.phone || '',
      email: formData.email || '',
      // nationality: formData.country || formData.nationality || 'UAE',
      extraData: {
        timestamp: new Date().toISOString(),
        ...(formData.extraData || {}),
      },
    };

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(pixxiData),
      redirect: 'follow',
    };

    const response = await fetch(PIXXI_API_URL, requestOptions);
    const result = await response.text();

    if (response.ok) {
      console.log('PIXXI CRM submission successful:', result);
      return {
        success: true,
        message: 'Form submitted successfully',
        data: result,
      };
    } else {
      console.error('PIXXI CRM submission failed:', response.status, result);
      return {
        success: false,
        message: 'Failed to submit form',
        error: result,
      };
    }
  } catch (error) {
    console.error('PIXXI CRM API error:', error);
    return {
      success: false,
      message: 'Network error occurred',
      error: error.message,
    };
  }
}

// Helper function to validate required fields
export function validateFormData(formData) {
  const errors = [];

  if (!formData.name || formData.name.trim().length < 2) {
    errors.push('Name is required and must be at least 2 characters');
  }

  if (!formData.phone || formData.phone.trim().length < 8) {
    errors.push('Phone number is required and must be at least 8 digits');
  }

  if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
    errors.push('Email format is invalid');
  }

  if (!formData.unitType || !formData.extraData?.unit_type) {
    errors.push('Unit type is required');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

// Helper function to format phone number
export function formatPhoneNumber(phone, countryCode) {
  if (!phone) return '';

  // Remove any non-digit characters
  const cleanPhone = phone.replace(/\D/g, '');

  // Add country code if not present
  if (countryCode && !cleanPhone.startsWith(countryCode.replace('+', ''))) {
    return `${countryCode}${cleanPhone}`;
  }

  return cleanPhone.startsWith('+') ? cleanPhone : `+${cleanPhone}`;
}
